import {Component, Input, OnInit} from '@angular/core';
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'bm-dunning-type-trigger-logic-field',
    templateUrl: './bm-dunning-type-trigger-logic-field.component.html',
    standalone: false
})
export class BmDunningTypeTriggerLogicFieldComponent implements OnInit {

    @Input() dunningTypeTriggerId: number;
    dunningTypeTriggerLogicFieldData: WidgetData;

    ngOnInit() {
        this.refreshDataWidget();
    }

    refreshDataWidget() {


        const filterCriteria = FilterCriteria.create('e.dunningProcessTypeTriggerId', FilterCriteria.cOperatorEqual, this.dunningTypeTriggerId);
        // this.dunningTypeTriggerLogicFieldData = WidgetFactory.createWidgetTableEntity(
        //     'bm.dunning.object.shared.dunning.type.trigger.logic.field',
        //     'Dunning Type Trigger Logic Field',
        //     'bm.DunningTypeTriggerLogicField',
        //     'Keine Einträge gefunden.',
        //     ObjectRequestList.createBasic(true, [filterCriteria], [])
        // );
        this.dunningTypeTriggerLogicFieldData = WidgetFactory.createWidgetTableEntityQl('bm.dunning.object.shared.dunning.type.trigger.logic.field', 'Dunning Type Trigger Logic Field', 'bm.DunningTypeTriggerLogicField', 'Keine Einträge gefunden.', [filterCriteria]);


        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'dunningProcessTypeTriggerDtoId', fieldValue: this.dunningTypeTriggerId}]

        this.dunningTypeTriggerLogicFieldData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }
}
